import base from './base.repository'
import base2 from './base2.repository'

export default {
    ...base,
    getClientById(id) {
        this.get(`clients/${id}`)
        return this
    },
    all(filters, page) {
        const params = {
            ...filters,
            page,
        }
        this.get(`clients${this.querify(params)}`)
        return this
    },
    getAll() {
        this.get('clients/all')
        return this
    },
    getIdentificationTypes() {
        this.get('clients/identification-types')
        return this
    },
    getClientTypes() {
        this.get('clients/client-types')
        return this
    },
    getClient(slug) {
        this.get(`clients/info/${slug}`)
        return this
    },
    saveClient(client) {
        return base2.post('clients', client)
        // this.post(`clients`, client);
        // return this;
    },
    updateClient(client, id) {
        this.put('clients/' + id, client)
        return this
    },
    deleteClient(id, userId) {
        this.delete('clients/' + id + '?user=' + userId)
        return this
    },
    activateClient(client) {
        this.post('clients/activate-client', client)
        return this
    },
    loadStructures(payload) {
        this.post('clients/structures/load', payload)
        return this
    },
    searchPersonOrStructure(payload) {
        // Obsoleto
        this.get(`clients/client/${payload.clientId}/search/${payload.search}`)
        return this
    },
    searchPerson(clientId, search) {
        // this.get(`clients/client/${clientId}/search/${search}`);
        this.get(`people?client=${clientId}&search=${search}`)
        return this
    },
    search(term) {
        this.get(`clients/search/${term}`)
        return this
    },
    assignUser(userId, structureId, assignedById) {
        this.post('clients/assign-to-client', {
            userId,
            structureId,
            assignedById,
        })
        return this
    },
    loadAssignations(clientId) {
        this.get(`clients/${clientId}/assignations`)
        return this
    },
    setAssignationStatus(assignationId, newStatus) {
        this.post('clients/assignations/changeStatus', {
            assignationId,
            newStatus,
        })
        return this
    },
    disassociate(assignationId) {
        this.post('clients/disassociate', {
            assignationId,
        })
        return this
    },
    getClientEntryTimes(clientId) {
        this.get(`clients/${clientId}/entry-times`)
        return this
    },
    saveEntryTimes(payload) {
        this.post(`clients/${payload.clientId}/save-entry-times`, {
            userId: payload.userId,
            times: payload.times,
        })
        return this
    },
    loadTools: (clientId) => base2.get(`clients/${clientId}/tools`),
    loadToolStatuses: () => base2.get(`tools/statuses`),
    assignationToolToClient(payload) {
        this.post(`clients/assign-tools`, {
            clientId: payload.clientId,
            selectedTools: payload.selectedTools,
        })
        return this
    },
    pendingClientTransactions(clientId) {
        this.get(`clients/${clientId}/load-pending-transactions`)
        return this
    },
    getVenuesByClient(clientId) {
        this.get(`venues?client=${clientId}`)
        return this
    },
    getClientsOptionalModule(filters) {
        const params = {
            ...filters,
        }
        this.get(`clients/optional_module${this.querify(params)}`)
        return this
    },
    getClientCustomers(filters) {
        const params = {
            ...filters,
        }
        this.get(`clients/customers${this.querify(params)}`)
        return this
    },
    getTowns: (filters = {}) => base2.get('towns', filters),
    getServiceSpotsByVenue: (venueId) =>
        base2.get(`venues/${venueId}/service-spots`),
}
